import {createContext} from 'react';

export const subscriberContext = createContext(null);